module.exports = __webpack_public_path__ + "img/wallet_desktop.952c445a.svg";